// extracted by mini-css-extract-plugin
export default {"arrow":"popperComponentStyles_arrow__bcM48"};